"use client";

import { Suspense, useEffect, useRef } from "react";
import { useSearchParams } from "next/navigation";

import {
  triggerPageViewEvent,
  PersonalizationInput,
  PageViewOptions,
} from "./trigger-analytics-event";
import { TrackingData } from "./types";

export type PageViewEventProps = Pick<TrackingData, "location" | "place"> & {
  personalization?: PersonalizationInput | null;
  platform: string;
  onPageView?: PageViewOptions["onPageView"];
};

function PageViewEventTracking({
  location,
  place,
  personalization,
  platform,
  onPageView,
}: PageViewEventProps) {
  const searchParams = useSearchParams();
  const emittedEvent = useRef(false);

  useEffect(() => {
    if (!emittedEvent.current) {
      triggerPageViewEvent({ location, place }, searchParams, personalization, {
        platform,
        onPageView,
      })
        .then(() => {
          emittedEvent.current = true;
        })
        .catch((err) => {
          console.error("Error sending page view event:", err);
        });
    }
  }, [location, place, searchParams, personalization, platform, onPageView]);

  return null;
}

export function PageViewEvent(props: PageViewEventProps) {
  return (
    <Suspense>
      <PageViewEventTracking {...props} />
    </Suspense>
  );
}
